import React from "react";
import ReactDOM from "react-dom";
import { Route, Switch, Redirect } from "react-router-dom";
import { IntlProvider } from "react-intl";
import { Provider } from "react-redux";
import "semantic-ui-css/semantic.min.css";
import { ConnectedRouter } from "connected-react-router";
import configureStore, { history } from "store";

import App from "containers/App";
import ThresholdForm from "containers/ThresholdForm";
import Reports from "containers/Reports";
import Detail from "containers/DetailedView";

import { isActiveLink, links, loadIntlMessages } from "utils";
import AuditLog from "components/AuditLogForm";
import APITokenPersistence from "components/APITokenPersistence";

// create the redux store with middlewares, e.g. redux-saga.
const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <APITokenPersistence>
      <IntlProvider {...loadIntlMessages()}>
        <ConnectedRouter history={history}>
          <Route
            render={({ location }) => (
              <App
                isActiveLink={isActiveLink}
                links={links}
                location={location}
                render={() => (
                  <Switch>
                    <Route
                      exact={true}
                      path="/"
                      render={() => <Redirect to="/riskUI/thresholds" />}
                    />
                    <Route
                      exact={true}
                      path="/riskUI"
                      render={() => <Redirect to="/riskUI/thresholds" />}
                    />
                    <Route
                      exact={true}
                      path="/riskUI/thresholds"
                      component={ThresholdForm}
                    />
                    <Route
                      exact={true}
                      path="/riskUI/reports/:date/:sliceid/:tkr/:cusip"
                      component={Reports}
                    />
                    <Route
                      exact={true}
                      path="/riskUI/reports/:date/:sliceid"
                      component={Reports}
                    />
                    <Route
                      exact={true}
                      path="/riskUI/reports"
                      component={Reports}
                    />
                    <Route exact={true} path="/log" component={AuditLog} />
                  </Switch>
                )}
              />
            )}
          />
        </ConnectedRouter>
      </IntlProvider>
    </APITokenPersistence>
  </Provider>,
  document.getElementById("root")
);

if (window.Cypress) {
  window.store = store;
}
